// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__39fNK","content":"LayoutSettings_content__2qQuY"};